import { formatDistanceToNowStrict, isValid, parseISO } from 'date-fns';
import { applySnapshot, getSnapshot, types as t } from 'mobx-state-tree';
import { OTP_TIMEOUT } from '../constants';

const OTPModel = t
  .model('OTPModel', {
    otpId: t.optional(t.string, ''),
    otpRef: t.optional(t.string, ''),
    authToken: t.optional(t.string, ''),
    expiredAt: t.optional(t.string, ''),
    email: t.optional(t.string, ''),
    phone: t.optional(t.string, ''),
    countryCode: t.optional(t.string, ''),
    resendAt: t.optional(t.string, ''),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
    };
  })
  .views((self) => ({
    get expiredSecond() {
      return isValid(new Date(self.resendAt))
        ? +formatDistanceToNowStrict(parseISO(self.resendAt), {
            unit: 'second',
          }).split(' ')[0]
        : OTP_TIMEOUT;
    },
  }));

export default OTPModel;
